import React from "react";
import * as fabric from "fabric";
import { useAppSelector } from "../../hook/redux";
import ClosingToolBarButton from "./ClosingToolBarButton";
import ImageEditor from "./ImageEditor/ImageEditor";
import LayoutEditor from "./LayoutEditor/LayoutEditor";
import TextEditor from "./TextEditor/TextEditor";
import { isDesktop, toolbarStyles } from "./utils";


function renderEditor(toolbarDisplay: string, canvas: fabric.Canvas) {
  switch (toolbarDisplay) {
    case "layout":
      return <LayoutEditor canvas={canvas} />;
    case "text":
      return <TextEditor canvas={canvas}/>;
    default:
      return <ImageEditor canvas={canvas} />;
  }
}

function Toolbar({canvas}) {
  const { toolbarDisplay } = useAppSelector( ( state ) => state.editor );

  const desktop = isDesktop();

    return (
      <>
          <div
            style={
              desktop
              ? toolbarStyles.desktop.closingButtonWrapper
              : toolbarStyles.mobile.closingButtonWrapper
            }
            className="closing-toolbar bg-white"
          >
            {toolbarDisplay.value !== "layout" && <ClosingToolBarButton canvas={ canvas } />}
        </div>
        <div className="d-flex d-md-block w-100 px-0 px-md-3">
          { renderEditor( toolbarDisplay.value, canvas ) }
        </div>
      </>
    );
}

export default Toolbar;